/**
 * @param {string} exchangeId
 * @param {ReturnType<import('./getQueryVersionNavState.js').getQueryVersionNavState>} query
 * @param {ReturnType<import('./getAssistantVersionNavState.js').getAssistantVersionNavState>} assistant
 * @param {{
 *   onSetExchangeActiveQueryVersion?: (id: string, idx: number) => void,
 *   onSetExchangeActiveAnswerVersion?: (id: string, idx: number) => void,
 * }} callbacks
 */
export function getExchangeRowHandlers(exchangeId, query, assistant, callbacks) {
  const { onSetExchangeActiveQueryVersion, onSetExchangeActiveAnswerVersion } = callbacks
  return {
    onQueryPrev: () => {
      if (!query?.queryCanPrev) return
      onSetExchangeActiveQueryVersion?.(exchangeId, query.queryPrevVersionIndex)
    },
    onQueryNext: () => {
      if (!query?.queryCanNext) return
      onSetExchangeActiveQueryVersion?.(exchangeId, query.queryNextVersionIndex)
    },
    onAnswerPrev: () => {
      if (!assistant.answerCanPrev) return
      onSetExchangeActiveAnswerVersion?.(exchangeId, assistant.answerPrevVersionIndex)
    },
    onAnswerNext: () => {
      if (!assistant.answerCanNext) return
      onSetExchangeActiveAnswerVersion?.(exchangeId, assistant.answerNextVersionIndex)
    },
  }
}
